<template>
    <img src="../../../public/images/logo2.png" v-if="colour" />
    <img src="../../../public/images/logo.png" v-else />
</template>

<script>
export default {
    props: {
        colour: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
